/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from 'react';
import {
    Diamond,
    ArrowUp,
    CircleDot,
    PlusCircle,
    Disc,
    Target,
} from 'lucide-react';

const benefits = [
    {
        id: 1,
        icon: <Diamond className="w-6 h-6 text-[#459ca5]" />,
        title: 'Simple by Design',
        description: 'Intuitive for every stakeholder — from the installer on site to the executive reviewing the dashboard.',
    },
    {
        id: 2,
        icon: <ArrowUp className="w-6 h-6 text-[#459ca5]" />,
        title: 'Built to Scale',
        description: 'Works for one building or a global portfolio of 1,000+ sites with no architecture changes needed.',
    },
    {
        id: 3,
        icon: <CircleDot className="w-6 h-6 text-[#459ca5]" />,
        title: 'Open & Licence-Free',
        description: 'No vendor lock-in. No software licence fees. Interoperable with the systems you already have.',
    },
    {
        id: 4,
        icon: <PlusCircle className="w-6 h-6 text-[#459ca5]" />,
        title: 'End-to-End Ownership',
        description: 'We design, manufacture, and support everything — no integration gaps, no hidden vendor layers.',
    },
    {
        id: 5,
        icon: <Disc className="w-6 h-6 text-[#459ca5]" />,
        title: 'Proven Globally',
        description: 'Trusted across Australia and deployed internationally — backed by 30+ years of industry experience.',
    },
    {
        id: 6,
        icon: <Target className="w-6 h-6 text-[#459ca5]" />,
        title: 'Support that Delivers',
        description: 'Hands-on support from plan and design through commissioning, handover and beyond.',
    },
];

const WhyNubeSection = () => {
    return (
        <section className="w-full py-20 lg:py-12 lg:mb-16">
            <div className="container max-w-[1440px] mx-auto px-6 lg:max-w-screen-xl">

                <div className="mb-16">
                    <span className="text-theme-teal font-bold text-sm tracking-[0.2em] uppercase">
                        WHY NUBE IO
                    </span>
                    <h2 className="mt-4 text-3xl md:text-5xl font-bold text-black dark:text-white tracking-tight">
                        Making smarter buildings accessible.
                    </h2>
                    <p className="mt-6 text-gray-400 font-light leading-relaxed text-base lg:text-xl">
                        Not just another meter. A complete, end-to-end energy intelligence platform —  built by experts who understand buildings inside and out.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {benefits.map((benefit) => (
                        <div
                            key={benefit.id}
                            className="p-8 border border-gray-200 rounded-xl hover:shadow-sm transition-shadow duration-300 flex flex-col items-start dark:bg-theme-tarjet/70 dark:border-theme-border"
                        >
                            <div className="w-12 h-12 bg-theme-teal/20 rounded-lg flex items-center justify-center mb-6">
                                {benefit.icon}
                            </div>
                            <h4 className="text-xl font-bold text-gray-900 mb-3 text-black text-base lg:text-lg dark:text-theme-teal">
                                {benefit.title}
                            </h4>
                            <p className="text-gray-400 leading-relaxed font-light">
                                {benefit.description}
                            </p>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default WhyNubeSection;
